import Redux from 'redux';
import * as Bixby from '$/core';
import {
  CloDealState,
  CLO_DEAL_FAILURE,
  CLO_DEAL_LOADING,
  CLO_DEAL_SUCCESS,
  CloDealActionTypes,
  HEATMAP_OFF,
  HEATMAP_ON,
  ALL_CLO_DEAL_SUCCESS,
  CREATE_CLO_DEAL,
  ADD_CLIENT_CLO_DEAL,
  ADD_CLIENT_CLO_DEAL_SUCCESS,
  ADD_CLIENT_CLO_DEAL_FAILURE,
  DELETE_CLIENT_CLO_DEAL,
  DELETE_CLIENT_CLO_DEAL_SUCCESS,
  DELETE_CLIENT_CLO_DEAL_FAILURE,
} from './types';

const initialState: CloDealState = {
  isLoading: false,
  error: undefined,
  currentCloDeal: undefined,
  heatMapActive: true,
  cloDeals: undefined,
  isAddingCloDealToClient: false,
};

const cloDealReducer: Redux.Reducer<CloDealState> = (state = initialState, action: CloDealActionTypes): CloDealState => {
  switch (action.type) {
    case CLO_DEAL_LOADING:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case CLO_DEAL_SUCCESS:
      const cloPayload = action.payload as Bixby.Models.CloDeal;
      return {
        ...state,
        isLoading: false,
        currentCloDeal: cloPayload,
        error: undefined,
      };
    case CLO_DEAL_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        currentCloDeal: undefined,
      };
    case HEATMAP_OFF:
      return {
        ...state,
        heatMapActive: action.payload as boolean,
      };
    case HEATMAP_ON:
      return {
        ...state,
        heatMapActive: action.payload as boolean,
      };
    case ALL_CLO_DEAL_SUCCESS:
      const allCloPayload = action.payload as Bixby.Models.CloDealSlim[];
      return {
        ...state,
        isLoading: false,
        cloDeals: allCloPayload,
        currentCloDeal: undefined,
        error: undefined,
      };
    case CREATE_CLO_DEAL:
      const createCloPayload = action.payload as Bixby.Models.CloDeal;
      return {
        ...state,
        isLoading: false,
        currentCloDeal: createCloPayload,
        error: undefined,
      };
    case ADD_CLIENT_CLO_DEAL:
      return {
        ...state,
        isAddingCloDealToClient: true,
      };
    case ADD_CLIENT_CLO_DEAL_SUCCESS:
      return {
        ...state,
        isAddingCloDealToClient: false,
      };
    case ADD_CLIENT_CLO_DEAL_FAILURE:
      return {
        ...state,
        isAddingCloDealToClient: false,
      };
    case DELETE_CLIENT_CLO_DEAL:
      return {
        ...state,
        isDeletingCloDealFromClient: true
      };
    case DELETE_CLIENT_CLO_DEAL_SUCCESS:
      return {
        ...state,
        isDeletingCloDealFromClient: false
      };
    case DELETE_CLIENT_CLO_DEAL_FAILURE:
      return {
        ...state,
        isDeletingCloDealFromClient: false,
        deletingCloDealFromClientError: (action.payload || {}) as Bixby.Models.BixbyError,
      };

    default:
      return state;
  }
};

export default cloDealReducer;
